/**
 * Checks wheter the placement of the tooltip would work
 * @param {object} tooltipRect  the result of getBoundingClientRect on the tooltip
 * @param {number} top
 * @param {number} left
 */
export function doesItFit(tooltipRect, top, left) {
  if (top + tooltipRect.height > document.documentElement.scrollHeight) {
    return false
  }
  if (left + tooltipRect.width > document.documentElement.scrollWidth) {
    return false
  }
  if (top < 0) {
    return false
  }
  if (left < 0) {
    return false
  }
  return true
}
